import { ChevronsUpDown } from "lucide-react";
import { useState } from "react";
import { type GovernanceUnitNode } from "~/api/types";
import { Button } from "~/atoms/button";
import { Popover, PopoverContent, PopoverTrigger } from "~/atoms/popover";
import { flattenGovernanceUnits } from "~/helpers/governanceUnit";
import { GovernanceUnitList } from "~/molecules/GovernanceUnitList";

interface Props {
  root: GovernanceUnitNode;
  value: number;
  onChange: (id: number) => void;
}

export function GovernanceUnitSelect({ root, value, onChange }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const selected = flattenGovernanceUnits([root]).find(
    (unit) => unit.id === value,
  );

  return (
    // Modal so the list scrolls inside a dialog.
    <Popover modal open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="field"
          role="combobox"
          aria-expanded={isOpen}
          className="w-full max-w-full min-w-0 shrink"
        >
          <span className="min-w-0 flex-1 truncate text-left">
            {selected?.name}
          </span>
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="p-0"
        style={{ width: "var(--radix-popover-trigger-width)" }}
        align="start"
      >
        <GovernanceUnitList
          root={root}
          selectedId={value}
          onSelect={(id) => {
            onChange(id);
            setIsOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
